<template>
  <div class="vb-quote-view">
    <b-container>
      <section class="section section--loader" v-if="loading">
        <loader size="large" :show_timing_slot="true" />
      </section>

      <section class="section" v-if="!loading">
        <div v-if="Object.keys(quote).length > 0">
          <quote :quote="quote" />
        </div>
        <div v-else>TODO error</div>
      </section>
    </b-container>
  </div>
</template>

<script>
import { mapState, mapGetters } from "vuex";

import { alpitour_service_handler } from "@alpitour/services/common";
import { normalize_check_to_quote } from "@alpitour/utilities/quote-normalize";
import Quote from "@alpitour/components/views/content-blocks/quote/quote.vue";

export default {
  name: "quote-view",
  components: {
    quote: Quote,
  },
  data() {
    return {
      loading: true,
    };
  },
  computed: {
    // global state keys
    ...mapState(["searching"]),
    // module state keys
    ...mapState("liveat", ["last_search", "current_search", "selected_room", "quote"]),
    ...mapGetters("liveat", ["is_only_stay_package"]),
  },
  mounted() {
    this.get_quote();
  },
  methods: {
    get_quote() {
      const { quote_payload } = this.selected_room;

      alpitour_service_handler("quote", quote_payload)
        .then(
          (success) => {
            this.log("[quote.vue] - success");
            this.log(success.data);

            const { data } = success.data;
            const { solution } = this.selected_room || {};
            const { dateFrom = "", dateTo = "" } = solution || {};

            const quote = this.is_only_stay_package
              ? normalize_check_to_quote(data, this.$store.state.occupancy, { checkin: dateFrom, checkout: dateTo })
              : data;
            this.$store.commit("liveat/quote", quote);
          },
          (error) => {
            this.log("[quote.vue] - error");
            this.log(error.response);
            this.$store.commit("liveat/quote", {});
          },
        )
        .finally(() => {
          this.loading = false;
        });
    },
  },
};
</script>
